import { AddWorkScheduleCommand } from "@/models/club";
import moment, { Moment } from "moment-jalaali";
import * as Yup from "yup";

export type AddWorkScheduleCommandForm = AddWorkScheduleCommand & {
  fromDateObject?: Moment;
  toDateObject?: Moment;
};

export const WeekDays = {
  1: "شنبه",
  2: "یکشنبه",
  3: "دوشنبه",
  4: "سه‌شنبه",
  5: "چهارشنبه",
  6: "پنجشنبه",
  7: "جمعه",
};

export const WeekDaysFa = {
  ش: 1,
  ی: 2,
  د: 3,
  س: 4,
  چ: 5,
  پ: 6,
  آ: 7,
};

// Helper function to format time with leading zeros
export const formatTime = (hour?: number, minute?: number): string => {
  const formattedHour = String(hour ?? 0).padStart(2, "0");
  const formattedMinute = String(minute ?? 0).padStart(2, "0");
  return `${formattedMinute} : ${formattedHour}`;
};

export type TimeSlot = {
  startTime: string;
  endTime: string;
};
export type AddTimeSlotType = {
  timeSlots: TimeSlot[];
};

// Helper function to convert time string to minutes
const timeToMinutes = (time: string): number => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

export const schema = Yup.object().shape({
  timeSlots: Yup.array()
    .of(
      Yup.object().shape({
        startTime: Yup.string().required("زمان شروع الزامی است"),
        endTime: Yup.string()
          .required("زمان پایان الزامی است")
          .test(
            "is-greater",
            "زمان پایان باید بزرگتر از زمان شروع باشد",
            function (endTime) {
              const { startTime } = this.parent;
              if (!startTime || !endTime) return true;
              return timeToMinutes(endTime) > timeToMinutes(startTime);
            }
          ),
      })
    )
    .test(
      "no-overlap",
      "بازه‌های زمانی نباید با یکدیگر تداخل داشته باشند",
      function (timeSlots) {
        if (!timeSlots || timeSlots.length === 0 || timeSlots.length <= 1)
          return true;

        // Sort time slots by start time
        const sortedSlots = [...timeSlots].sort(
          (a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime)
        );

        // Check for overlaps
        for (let i = 0; i < sortedSlots.length - 1; i++) {
          const currentEnd = timeToMinutes(sortedSlots[i].endTime);
          const nextStart = timeToMinutes(sortedSlots[i + 1].startTime);

          if (currentEnd > nextStart) {
            return this.createError({
              path: `timeSlots`,
              message: "بازه‌های زمانی نباید با یکدیگر تداخل داشته باشند",
            });
          }
        }

        return true;
      }
    ),
});

export const generateTimeOptions = () => {
  const times: string[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 5) {
      const hourStr = hour.toString().padStart(2, "0");
      const minuteStr = minute.toString().padStart(2, "0");
      times.push(`${hourStr}:${minuteStr}`);
    }
  }
  return times;
};

// Helper function to add hours to a time string
export const addHoursToTime = (time: string, hoursToAdd: number): string => {
  const [hours, minutes] = time.split(":").map(Number);
  let newHours = hours + hoursToAdd;

  // Wrap around if exceeds 24 hours
  if (newHours >= 24) {
    newHours = newHours % 24;
  }

  const hourStr = newHours.toString().padStart(2, "0");
  const minuteStr = minutes.toString().padStart(2, "0");
  return `${hourStr}:${minuteStr}`;
};

export const schemaAddWorkScheduleCommand = Yup.object().shape({
  fromDateObject: Yup.mixed()
    .required("تاریخ شروع الزامی است")
    .test("is-date-object", "تاریخ شروع معتبر نیست", (value: unknown) => {
      return value !== undefined && value !== null;
    }),
  toDateObject: Yup.mixed()
    .required("تاریخ پایان الزامی است")
    .test("is-date-object", "تاریخ پایان معتبر نیست", (value: unknown) => {
      return value !== undefined && value !== null;
    })
    .test(
      "is-after-from-date",
      "تاریخ پایان باید بزرگتر از تاریخ شروع باشد",
      function (value: unknown) {
        console.log(moment(value as Moment).format("YYYY-MM-DD"));

        const { fromDateObject } = this.parent;
        if (!fromDateObject || !value) return true;

        console.log(moment(fromDateObject).format("YYYY-MM-DD"));

        const error = moment(value).isAfter(moment(fromDateObject));
        console.log(error);
        return error;
      }
    ),
  weekDays: Yup.array()
    .min(1, "حداقل یک روز هفته باید انتخاب شود")
    .required("انتخاب روز هفته الزامی است"),
});
